let buyerOptions = [
	<option value='buyerAll'>All</option>,
	<option value='buyerBehalf'>Sent on behalf of me</option>,
	<option value='buyerOrders'>My orders</option>,
];

export default buyerOptions;
